module.exports = __webpack_public_path__ + "4a3d81fb02c913086a4cf0b5e5f30797.png";